import { castArray } from 'vtils'
import { OneOrMore } from 'vtils/types'
import { useContext } from './use_context'

export function useQuery<T extends Record<string, any>>(config?: {
  [K in keyof T]?: {
    alias?: OneOrMore<string>
    default?: T[K]
    transformer?: (value: string) => T[K]
  }
}): T {
  const ctx = useContext()
  const fromQuery = (ctx.$route.query || {}) as any
  const toQuery = { ...fromQuery } as T

  if (config) {
    for (const toKey of Object.keys(config) as Array<keyof T>) {
      if (config[toKey]) {
        if (config[toKey]!.alias) {
          for (const fromKey of castArray(config[toKey]!.alias)) {
            if (fromQuery[fromKey] != null) {
              toQuery[toKey] = fromQuery[fromKey]
              break
            }
          }
        }
        if (toQuery[toKey] != null) {
          if (config[toKey]!.transformer) {
            toQuery[toKey] = config[toKey]!.transformer!(toQuery[toKey])
          }
        } else {
          if (config[toKey]!.default != null) {
            toQuery[toKey] = config[toKey]!.default!
          }
        }
      }
    }
  }

  return toQuery
}
